import React from 'react'

const UploadIcon = ({ width = "16", height = "16", style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <mask
        id="mask0_222_5795"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_222_5795)">
        <path
          d="M4.00033 13.3327C3.63366 13.3327 3.31988 13.2022 3.05899 12.9413C2.79766 12.68 2.66699 12.366 2.66699 11.9993V9.99935H4.00033V11.9993H12.0003V9.99935H13.3337V11.9993C13.3337 12.366 13.2032 12.68 12.9423 12.9413C12.681 13.2022 12.367 13.3327 12.0003 13.3327H4.00033ZM7.33366 10.666V5.23268L5.60033 6.96602L4.66699 5.99935L8.00033 2.66602L11.3337 5.99935L10.4003 6.96602L8.66699 5.23268V10.666H7.33366Z"
          fill="#3249D7"
        />
      </g>
    </svg>
  )
}

export default UploadIcon
